import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, Button } from '@haldor/ui';
import { getRootUrl } from 'helpers/url';
import './_web.scss';
var DesktopHeader = /*#__PURE__*/function (_Component) {
  function DesktopHeader() {
    var _this;
    _classCallCheck(this, DesktopHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DesktopHeader, [].concat(args));
    _defineProperty(_this, "renderAction", function (action, index) {
      switch (action.type) {
        case 'button':
          return /*#__PURE__*/React.createElement(Button, {
            key: 'action-' + index,
            type: action.buttonType,
            disabled: action.disabled,
            onClick: action.onClick
          }, action.value);
        case 'icon':
          return /*#__PURE__*/React.createElement(Link, {
            key: 'action-' + index,
            className: "header-action",
            "data-tooltip": action.tooltip,
            onClick: action.onClick
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Cog"
          }));
        default:
          return null;
      }
    });
    return _this;
  }
  _inherits(DesktopHeader, _Component);
  return _createClass(DesktopHeader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "desktop-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement(Link, {
        to: getRootUrl()
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/img/logo_type_small.png",
        className: "logotype"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, this.props.settings.actions != null ? this.props.settings.actions.map(this.renderAction) : null)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    settings: state.Header
  };
}
export default connect(mapStateToProps)(DesktopHeader);